import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const inboundShipmentLocaleModule: LocaleModule = {
  name: "inboundShipment",
  messages: { en: en, it: it },
};
